// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2E8uk","title":"Header_title__4r8Pf","left":"Header_left__12o1s","clinicName":"Header_clinicName__2wiKC"};